import { render, staticRenderFns } from "./ui-modal.vue?vue&type=template&id=c6f9208c&"
import script from "./ui-modal.vue?vue&type=script&lang=js&"
export * from "./ui-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f9208c')) {
      api.createRecord('c6f9208c', component.options)
    } else {
      api.reload('c6f9208c', component.options)
    }
    module.hot.accept("./ui-modal.vue?vue&type=template&id=c6f9208c&", function () {
      api.rerender('c6f9208c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/ui-modal.vue"
export default component.exports